import cn from 'classnames';
import { Popup } from 'konsta/react';
import {useRef,useEffect,useState} from 'react';
import { useTransition, animated } from "@react-spring/web";
import { select } from '@material-tailwind/react';

const toPesos=function(n){
    const options = { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    };
    return Number(n).toLocaleString('en', options);  
}


const FoodDetailModal = ({ foodItem, onClose }) => {
    
   
    const modifCheckbox=(mod, idx)=>{
        const el=document.querySelector(`[data-mod="${mod.id}"][data-idx="${idx}"] input`);
        
        const model=document.querySelector(`[data-key="mod${mod.id}"]`);
        if(mod.max==1 ){
            el.checked=!el.checked;
            //uncheck all others
            model.querySelectorAll(`input[type='checkbox']`).forEach(i=>i!==el?i.checked=false:null);
        }if(mod.max>1){
            //count checked
            const checked=model.querySelectorAll(`input[type='checkbox']:checked`);
            if(checked.length==mod.max && !el.checked){
                return;
            }else{
                el.checked=!el.checked;
            }
        }
        recalcPlato();
    };
    const getOptsForMod=(mod_id)=>{
        const model=document.querySelector(`[data-key="mod${mod_id}"]`);
        let r=[];
        model.querySelectorAll('.opt').forEach((v,k)=>{
           let w={
            idx:v.getAttribute('data-idx'),
            price:parseFloat(v.getAttribute('data-prix')),
            nombre:v.querySelector('span').innerText,
           };
           if(v.querySelectorAll('.stepper').length>0){
            w.value=parseInt(v.querySelector('.stepper').innerText);
           }else{
            w.value=v.querySelector('input').checked?1:0;
           }
           r.push(w);
        });
        return r;
    }
    const getExtras=()=>{  
        let ret=foodItem?.modificadores?.map(mod=>{
            let r={
                prod_id:foodItem.id,
                mod_id:mod.id,
                mult:mod.mult??1,
                min:mod.min,
                max:mod.max,
                count:mod.count,
                nombre:mod.nombre,
                shown:mod.shown,
                opciones:getOptsForMod(mod.id)
            }
            r.cVal=r.opciones.reduce((tot,x)=>tot+x.value,0);
            r.cPrice=r.opciones.reduce((tot,x)=>tot+(x.value*x.price*r.mult),0);
            return r;
        });
        return ret;
    }
    const addPlato=(am)=>{
        const q=parseInt(document.querySelector('#numPlatosStepper span:nth-child(2)').innerText);
        document.querySelector('#numPlatosStepper span:nth-child(2)').innerText=Math.max(1,q+am);
        recalcPlato();
    }
    const recalcPlato=()=>{
        const extras=getExtras();
        let p=foodItem.precio;
        const q=parseInt(document.querySelector('#numPlatosStepper span:nth-child(2)').innerText);
        let total=parseFloat(p);
        let isValid=true;
        extras?.map(el=>{
            isValid=isValid && (el.min<=el.cVal);
            total+=+el.cPrice;
        });
        document.querySelector('#totalPrice').innerHTML=toPesos(total*q);
        document.querySelector('#addToCartButton').disabled=!isValid;
    }
    const addOpt=(mod_id, opt_idx, am)=>{
        const model=document.querySelector(`[data-key="mod${mod_id}"]`);
        const stepper=model.querySelector(`[data-idx="${opt_idx}"] .stepper`);
        let q=parseInt(stepper.innerText);
        const mod=foodItem.modificadores.find(m=>m.id==mod_id);
        const max=mod.max;
        const totalAct=[...model.querySelectorAll('.stepper')].reduce((tot,x)=>tot+parseInt(x.innerText),0);
        if(totalAct<max && am>0){
           stepper.innerText=q+am;
        }
        if(am<0){
            stepper.innerText=Math.max(0,q+am);
        }
        recalcPlato();
    }
    const addProducto=()=>{
        const extras=getExtras();
        let mods=[],
        pextras=0;
        extras.map(el=>{
            pextras+=el.cPrice;
            if(el.cVal>0){
                mods.push({
                    id:el.mod_id,
                    mult:el.mult??1,
                    nombre:el.nombre,
                    shown:el.shown,
                    prodid:el.prod_id,
                    opts:el.opciones.filter(o=>o.value>0)
                });
            }
        });
        const prod2add={
            prod_id:foodItem.id,
            es_kit:foodItem.es_kit,
            kit_data:foodItem.kit_data,
            nombre:foodItem.nombre,
            modificadores:mods,
            q:parseInt(document.querySelector('#numPlatosStepper span:nth-child(2)').innerText),
            comentarios:document.querySelector('#specialInstructions').value,
            precio:foodItem.precio,
            precio_extras:pextras,
        };
        if(!localStorage.getItem('cart')){
            localStorage.setItem('cart', JSON.stringify([prod2add]));
        }else{
            const cart=JSON.parse(localStorage.getItem('cart'));
            cart.push(prod2add);
            localStorage.setItem('cart', JSON.stringify(cart));
        }
        onClose();
    }
    useEffect(()=>{
        document.querySelector('#numPlatosStepper span:nth-child(2)').innerHTML=1;
        document.querySelector("#specialInstructions").value='';
        recalcPlato();
    },[foodItem]);
    return (
    
        <Popup  id="food-modal"  opened={foodItem} onBackdropClick={onClose} className='z-50 overflow-scroll '>
            <div className={cn("text-neutral-700 min-h-screen flex bg-white  justify-center  ")}>
                    <div className="bg-white w-full h-auto  flex flex-col animate-fadeIn">
                        <div className="relative h-24 overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1568901346375-23c9450c58cd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80"
                                alt="Classic Cheeseburger"
                                className="w-full h-full object-cover"
                                keywords="burger, cheeseburger, fast food"
                            />
                            <label
                                htmlFor="food-modal"
                                className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm text-black rounded-full flex items-center justify-center hover:bg-white transition-colors shadow-md cursor-pointer z-50"
                                onClick={onClose}
                            >
                                <span className="material-symbols-outlined " >close</span>
                            </label>
                            <div className="absolute bottom-0 left-0 right-0  bg-gradient-to-t from-black/70 to-transparent p-4">
                                <h2 className="text-xl font-bold text-white">{foodItem.nombre}</h2>
                                <span className="inline-block mt-1 bg-primary-500 text-white text-xs font-semibold px-2 py-1 rounded">
                                    {foodItem.cat_nombre}
                                </span>
                            </div>
                        </div>

                        <div className="p-4 overflow-y-auto flex-1">
                            <p className="text-neutral-600 mb-5">
                                {foodItem.descripcion }
                            </p>

                        { (foodItem.modificadores && foodItem.modificadores.length>0) && foodItem.modificadores.map((mod, index) => (
                            <div key={"mod"+mod.id} className="mb-6" data-key={`mod${mod.id}`}>
                                 <h3 className="font-bold mb-3 text-neutral-800 border-b pb-2">{mod.nombre}</h3>
                                 
                                    {mod.min==mod.max && (<small> Selecciona {mod.min} </small>)}
                                    {(mod.min!=mod.max && mod.min==0) && (<small>Selecciona hasta {mod.max}</small>)}
                                    {(mod.min!=mod.max && mod.min>0) && (<small>Selecciona entre {mod.min} y {mod.max}</small>)}
                            
                            
                            
                                <div className="space-y-3">
                                    {mod.count==1 && mod.opciones.map((opt, optIndex) => (
                                      <div data-prix={opt.precio} data-idx={optIndex} data-mod={mod.id} className="opt flex items-center justify-between p-3 border border-neutral-200 rounded-lg hover:bg-neutral-50 transition-colors cursor-pointer"
                                        key={"opt"+index+"_"+optIndex} 
                                        
                                        onClick={() => {
                                                // Handle option selection
                                                modifCheckbox(mod, optIndex);
                                            }}
                                      >
                                        <span className="font-medium">{opt.nombre}</span>
                                        <div className="flex items-center ">
                                            <span className="mr-3 text-neutral-600">{opt.precio>0?`+$${toPesos(opt.precio)}`:""}</span>
                                            <input
                                                type="checkbox"
                                                className="w-5 h-5 accent-primary-600 rounded pointer-events-none"
                                            />
                                        </div>
                                     </div>  
                                    ))}
                                    {mod.count>1 && mod.opciones.map((opt, optIndex) => (
                                        <div data-prix={opt.precio} data-idx={optIndex} data-mod={mod.id} className="opt flex items-center justify-between p-3 border border-neutral-200 rounded-lg hover:bg-neutral-50 transition-colors"
                                            key={"opt"+index+"_"+optIndex}
                                        >
                                            <span className="font-medium">{opt.nombre}</span>
                                            <div className="flex items-center">
                                                <span className="mr-3 text-neutral-600">{opt.precio>0?`+$${toPesos(opt.precio)}`:""}</span>
                                                <div className="flex items-center border border-neutral-300 rounded-lg overflow-hidden">
                                                    <button className="w-8 h-8 flex items-center justify-center bg-neutral-100 hover:bg-neutral-200 transition-colors"
                                                        onClick={()=>{addOpt(mod.id, optIndex, -1)}}
                                                    >
                                                        <span className="material-symbols-outlined text-lg">remove</span>
                                                    </button>
                                                    <span className="w-8 h-8 flex items-center justify-center font-medium stepper">
                                                        0
                                                    </span>
                                                    <button className="w-8 h-8 flex items-center justify-center bg-neutral-100 hover:bg-neutral-200 transition-colors"
                                                        onClick={()=>{addOpt(mod.id, optIndex, 1)}}
                                                    >
                                                        <span className="material-symbols-outlined text-lg">add</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                </div>
                        ))}
                           
                                

                            

                            <div className="mb-4">
                                <h3 className="font-bold mb-3 text-neutral-800 border-b pb-2">Instrucciones especiales</h3>
                                <textarea
                                    placeholder="¿Algún requerimiento especial?"
                                    className="w-full p-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent resize-none h-20"
                                    id="specialInstructions"
                                ></textarea>
                            </div>
                        </div>

                        <div className="p-4 border-t border-neutral-200 bg-white pb-20 bottom-0 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
                            <div className="flex items-center justify-between mb-4">
                                <div className="flex items-center gap-2">
                                    <span className="font-medium">Cantidad:</span>
                                    <div className="flex items-center border border-neutral-300 rounded-lg overflow-hidden" id="numPlatosStepper">
                                        <button className="w-8 h-8 flex items-center justify-center bg-neutral-100 hover:bg-neutral-200 transition-colors"
                                            onClick={() => addPlato(-1)}>
                                            <span className="material-symbols-outlined text-lg">remove</span>
                                        </button>
                                        <span className="w-8 h-8 flex items-center justify-center font-medium">1</span>
                                        <button className="w-8 h-8 flex items-center justify-center bg-neutral-100 hover:bg-neutral-200 transition-colors"
                                            onClick={() => addPlato(1)}>
                                            <span className="material-symbols-outlined text-lg">add</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="font-bold text-lg">Total: $<span id="totalPrice"></span></div>
                            </div>
                            <button className="w-full py-3 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 transition-all duration-300 transform active:scale-98 flex items-center justify-center gap-2 shadow-md disabled:opacity-50 disabled:pointer-events-none" 
                                id="addToCartButton"
                                onClick={addProducto}    
                            >
                                <span className="material-symbols-outlined">shopping_cart</span>
                                Agregar al carrito
                            </button>
                        </div>
                    </div>
                </div>
            </Popup>
        
    );
}

export default FoodDetailModal;